import adserver, { AxiosError } from 'services/adserver';
import {
  useQuery,
  UseQueryOptions,
  UseQueryResult,
} from '@tanstack/react-query';
import { basketsKeys } from './baskets.keys';
import { BasketParams } from './baskets.types';

const getAllCampaignBaskets: {
  (campaignId: string): Promise<BasketParams[]>;
} = async (campaignId: string) => {
  const res = await adserver({
    url: `/campaign/${campaignId}/baskets`,
    method: 'GET',
    headers: {},
  });
  return res.data;
};

export const useGetCampaignBaskets = <TData = BasketParams[]>(
  campaignId: string,
  options?: Omit<
    UseQueryOptions<BasketParams[], AxiosError, TData>,
    'queryKey' | 'queryFn'
  >,
): UseQueryResult<TData, AxiosError> => {
  return useQuery<BasketParams[], AxiosError, TData>({
    queryKey: basketsKeys.list({ campaignId }),
    queryFn: () => getAllCampaignBaskets(campaignId),
    refetchOnWindowFocus: false,
    keepPreviousData: true,
    ...options,
  });
};
